import React, {useEffect} from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import imgOne from './images/port-pro-one.png';
import imgTwo from './images/shopping-cart.jpg';
import imgThree from './images/cv-temp-one.png';
import imgFour from './images/weather-img-one.png';
import imgFive from './images/weather-img-two.png';
import imgSix from './images/costar-clone-three.png';
//



function ShowGlass() {

    useEffect(() => {
        Aos.init({duration: 1500, offset: 300})
    }, [])

    return (
        <div className='port-project-div'>
            <div>
                <h3 className='port-header'>Portfolio project</h3>
          </div>
            <div className='project-div'>
                <div data-aos='fade-left' className='project-case project-case-type-one one'>
                    <div className='project-img-div project-img-div-one'>
                        <img alt='project-image' src={imgOne} />
                        <img alt='project-image' src={imgSix} />
                        <div className='div-img-overlay port-overlay'>
                            <div className='mobile-description'>
                                <div className='project-title-div'>
                                    <span className='project-title'>Personal Project</span>
                                    <span className='project-name'>Landing Page</span>
                                </div>
                                <div className='mob-description-p'>
                                    <p>A web app proudly built with React barely a week I started learning the UI library. I tried to make it look 80% similar to the <a href='https://www.costar.com/about' target='_blank' className='port-link'>original website</a> as at when it was built.</p>
                                </div>
                                <div className='mob-tech-list'>
                                    <span>React</span>
                                    <span>RWD</span>
                                    <span>Git</span>
                                    <span>GitHub pages</span>
                                </div>
                                <div className='project-links'>
                                    <span><a href='https://github.com/Alat-star/landing-page-proto' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                                    <span><a href='https://alat-star.github.io/landing-page-proto/' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='description-div'>
                        <div className='project-title-div'>
                            <span className='project-title'>Odin Project</span>
                            <span className='project-name'>Landing Page</span>
                        </div>
                        <div className='app-description'>
                            <p>A web app proudly built with React barely a week I started learning the UI library. I tried to make it look 80% similar to the <a href='https://www.costar.com/about' target='_blank' className='port-link'>original website</a> as at when it was built.</p>
                        </div>
                        <div className='project-img-div  tab-mode'>
                            <img alt='project-image' src={imgOne} />
                            <img alt='project-image' src={imgSix} />
                            <div className='div-img-overlay'></div>
                        </div>
                        <ul className='tech-list'>
                            <li>React</li>
                            <li>RWD</li>
                            <li>Git</li>
                            <li>GitHub pages</li>
                        </ul>
                        <div className='project-links project-links-mid'>
                            <span><a href='https://github.com/Alat-star/landing-page-proto' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                            <span><a href='https://alat-star.github.io/landing-page-proto/' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                        </div>
                    </div>
                </div>
                <div data-aos='fade-right' className='project-case pjt-case-type-two'>

                    <div className='description-div t2-description-div'>
                        <div className='project-title-div t2-project-title-div'>
                            <span className='project-title'>Odin Project</span>
                            <span className='project-name'>Shopping Cart</span>
                        </div>
                        <div className='app-description t2-app-description'>
                            <p>An app with three functioning routes (catalog, slider, cart) that let users shop and add item to cart, increase or decrease its quantity, cancel, and checkout.</p>
                        </div>
                        <div className='project-img-div  tab-mode'>
                            <img alt='project-image' src={imgTwo} />
                            <div className='div-img-overlay'></div>
                        </div>
                        <ul className='tech-list t2-tech-list'>
                            <li>React</li>
                            <li>Fake API</li>
                            <li>React-router</li>
                            <li>Git</li>
                            <li>GitHub pages</li>
                        </ul>
                        <div className='project-links t2-project-links'>
                            <span><a href='https://github.com/Alat-star/odin-shopping-cart' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                            <span><a href='https://alat-star.github.io/odin-shopping-cart/#/' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                        </div>
                    </div>
                    <div className='project-img-div prj-img-two'>
                        <img src={imgTwo} />
                        <div className='div-img-overlay port-overlay'>
                            <div className='mobile-description'>
                                <div className='project-title-div'>
                                    <span className='project-title'>Odin Project</span>
                                    <span className='project-name'>Shopping Cart</span>
                                </div>
                                <div className='mob-description-p'>
                                    <p>An app with three functioning routes (catalog, slider, cart) that let users shop and add item to cart, increase or decrease its quantity, cancel, and checkout.</p>
                                </div>
                                <div className='mob-tech-list'>
                                    <span>React</span>
                                    <span>Fake API</span>
                                    <span>React-router</span>
                                    <span>Git</span>
                                    <span>GitHub pages</span>
                                </div>
                                <div className='project-links'>
                                    <span><a href='https://github.com/Alat-star/odin-shopping-cart' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                                    <span><a href='https://alat-star.github.io/odin-shopping-cart/#/' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div data-aos='fade-left' className='project-case project-case-type-one'>
                    <div className='project-img-div'>
                        <img src={imgThree} />
                        <img src={imgThree} />
                        <div className='div-img-overlay port-overlay'>
                            <div className='mobile-description'>
                                <div className='project-title-div'>
                                    <span className='project-title'>Odin Project</span>
                                    <span className='project-name'>CV App</span>
                                </div>
                                <div className='mob-description-p'>
                                    <p>A prototype web app for building Resume with image, a type of resume that catches recruiter's attention compared to the common boring all-text only. It's only desktop responsive atm.</p>
                                </div>
                                <div className='mob-tech-list'>
                                    <span>React</span>
                                    <span>Cloudinary</span>
                                    <span>Firestore</span>
                                    <span>GitHub pages</span>
                                </div>
                                <div className='project-links project-links-mid'>
                                    <span><a href='https://github.com/Alat-star/cv-template' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                                    <span><a href='https://alat-star.github.io/cv-template/' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='description-div t3-description'>
                        <div className='project-title-div'>
                            <span className='project-title'>Odin Project</span>
                            <span className='project-name'>CV App</span>
                        </div>
                        <div className='app-description project-three'>
                            <p>A prototype web app for building Resume with image, a type of resume that catches recruiter's attention compared to the common boring all-text only. It's only desktop responsive atm.</p>
                        </div>
                        <div className='project-img-div  tab-mode'>
                            <img alt='project-image' src={imgThree} />
                            <img alt='project-image' src={imgThree} />
                            <div className='div-img-overlay'></div>
                        </div>
                        <ul className='tech-list'>
                            <li>React</li>
                            <li>Firestore</li>
                            <li>Cloudinary</li>
                            <li>GitHub pages</li>
                        </ul>
                        <div className='project-links'>
                            <span><a href='https://github.com/Alat-star/cv-template' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                            <span><a href='https://alat-star.github.io/cv-template/' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                        </div>
                    </div>
                </div>
                <div data-aos='fade-right' className='project-case pjt-case-type-two'>

                    <div className='description-div t2-description-div'>
                        <div className='project-title-div t2-project-title-div'>
                            <span className='project-title'>Odin Project</span>
                            <span className='project-name'>Weather App</span>
                        </div>
                        <div className='app-description t2-app-description'>
                            <p>A weather forecast app that tells user about weather condition, temperature, humidity, visibility, pressure of any location in the world.</p>
                        </div>
                        <div className='project-img-div  tab-mode'>
                            <img alt='project-image' src={imgFour} />
                            <img alt='project-image' src={imgFive} />
                            <div className='div-img-overlay'></div>
                        </div>
                        <ul className='tech-list t2-tech-list'>
                                <li>JavaScript(ES6+)</li>
                                <li>API</li>
                                <li>AJAX</li>
                                <li>Git</li>
                                <li>Webpack</li>
                                <li>GitHub pages</li>
                        </ul>
                        <div className='project-links t2-project-links'>
                            <span><a href='https://github.com/Alat-star/weather-app' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                            <span><a href='https://alat-star.github.io/weather-app/?location=#' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                        </div>
                    </div>
                    <div className='project-img-div prj-img-two'>
                        <img src={imgFour} alt='weather-app' />
                        <img src={imgFive} alt='weather-app' />
                        <div className='div-img-overlay port-overlay'>
                            <div className='mobile-description'>
                                <div className='project-title-div'>
                                    <span className='project-title'>Odin Project</span>
                                    <span className='project-name'>Weather App</span>
                                </div>
                                <div className='mob-description-p'>
                                    <p>A weather forecast app that tells user about weather condition, temperature, humidity, visibility, pressure of any location in the world.</p>
                                </div>
                                <div className='mob-tech-list'>
                                    <span>JavaScript(ES6+)</span>
                                    <span>API</span>
                                    <span>AJAX</span>
                                    <span>Git</span>
                                    <span>Webpack</span>
                                    <span>GitHub pages</span>
                                </div>
                                <div className='project-links'>
                                    <span><a href='https://github.com/Alat-star/weather-app' target='_blank'><FontAwesomeIcon size='1x' icon={["fab", "github"]} /></a></span>
                                    <span><a href='https://alat-star.github.io/weather-app/?location=#' target='_blank' ><FontAwesomeIcon size='1x' icon={["fas", "external-link-alt"]} /></a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShowGlass
